import type { ButtonHTMLAttributes } from 'react';
import {
  Button as ShadcnButton,
  type ButtonSize,
  type ButtonVariant,
} from '@/components/ui/button.js';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md';
};

/*
 * The console's button vocabulary, mapped onto shadcn's.
 *
 * Kept as a distinct module rather than a re-export: every screen already
 * imports `variant="primary"` and `size="md"`, and those names say what the
 * button *means* here (primary = the one commit action on the screen) where
 * shadcn's say what it looks like. One translation table beats renaming fifty
 * call sites.
 */
const VARIANTS: Record<NonNullable<ButtonProps['variant']>, ButtonVariant> = {
  primary: 'default',
  secondary: 'outline',
  ghost: 'ghost',
  danger: 'destructiveOutline',
};

const SIZES: Record<NonNullable<ButtonProps['size']>, ButtonSize> = {
  sm: 'sm',
  md: 'default',
};

export function Button({ variant = 'secondary', size = 'md', ...rest }: ButtonProps) {
  return <ShadcnButton variant={VARIANTS[variant]} size={SIZES[size]} {...rest} />;
}
